import React from 'react';

export const WizardContext = React.createContext<{ wizardState: unknown; reducerWizardDispatch: unknown }>({
  wizardState: {},
  reducerWizardDispatch: {},
});
